module.exports = __webpack_public_path__ + "img/img_sub_prod_tibco01.bd4e7d19.svg";